/**
 * Shared React Query options for the Campaigns reads.
 *
 * Every query hook in this domain is a look-only read, so they all want the
 * same two things and for the same reasons (the apply/remove mutations are
 * not queries and do not use these):
 *
 * - `retry: false` — a campaign-service outage should surface on the page at
 *   once rather than stalling it behind three silent retries.
 * - `refetchOnWindowFocus: false` — none of these surfaces is worth a fresh
 *   request every time the admin tabs back to the window.
 *
 * Spread into each `useQuery` so the decision lives in one place; a hook that
 * needs a different policy overrides by listing the key after the spread.
 */
export const READ_ONLY_QUERY_OPTIONS = {
  retry: false,
  refetchOnWindowFocus: false,
};
